import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function PE() {
  const { t } = useTranslation(); // 預設使用 'translation' namespace

  return (
    <div className="article-container">
      <h1>{t('pe.title')}</h1>
      <p>{t('pe.paragraph1')}</p>

      <h2>{t('pe.interpretationHeading')}</h2>
      <p>{t('pe.paragraph2')}</p>

      <h2>{t('pe.formulaHeading')}</h2>
      <p>{t('pe.paragraph3')}</p>
      <pre>{t('pe.formula')}</pre>

      <h2>{t('pe.exampleHeading')}</h2>
      <p>{t('pe.paragraph4')}</p>
      <pre>{t('pe.exampleCalculation')}</pre>
      <p>{t('pe.paragraph5')}</p>
    </div>
  );
}

export default PE;
